(() => {
    const topOptionsComplects = {
        template: '#topOptionsComplects',
        props: ['check', 'clientcode', 'cartsended'],
        emits: ['cart-sent'],
        computed: {
            computedCheck() {
                console.log('%cVue %ctopOptionsComplects %ccomputedCheck()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                return calcCheckSummary(this.check);
            }
        },
        methods: {
            sendToCart() {
                console.log('%cVue %ctopOptionsComplects %csendToCart()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                sendCheckToCart(this.check);
                this.$emit('cart-sent');
                window.dispatchEvent(new CustomEvent('complect-cart-sent'));
            },
            locateToCart() {
                console.log('%cVue %ctopOptionsComplects %clocateToCart()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                window.location = '/cart/';
            }
        }
    }

    if (typeof Vue !== 'undefined') {
        const topItemListApp = Vue.createApp({
            data() {
                return {
                    check: window.check,
                    cartsended: false,
                    clientcode: window.clientcode
                }
            },
            methods: {
                updateCheck(newcheck) {
                    console.log('%cVue %ctopItemListApp %cupdateCheck()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                    this.check = newcheck;
                },
                cartSended() {
                    console.log('%cVue %ctopItemListApp %ccartSended()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                    this.cartsended = true;
                }
            }
        });

        topItemListApp.component('main-options-complects', topOptionsComplects);
        window.topItemListApp = topItemListApp.mount('#appOptionsComplectsTop');

        window.addEventListener('complect-check-updated', e => window.topItemListApp.updateCheck(e.detail));
        window.addEventListener('complect-cart-sent',    () => window.topItemListApp.cartSended());
    }
})()
